<template>
  <div :class="[active?'active-grasimi':'']">
    <div class="row height-row" @click="active=!active">
      <div class="col-md-4 col-4 border-table">
        <span v-if="!active" class="plus">+</span>
        <span v-else class="minus">-</span>
        <span class="span-black pl-0">Proteine</span>
      </div>
      <div class="col-md-4 col-4 border-table"><span class="span-black">7.7 g</span></div>
      <div class="col-md-4 col-4 border-table border-last"><span class="span-black">1.1 g</span></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "proteine",
  data() {
    return {
      active: false
    }
  }
}
</script>

<style scoped>

</style>
